export const CORRIDOR_TYPES = {
  IN_TRANSIT: 'RIT',
  IN_HOUSE: 'RIH'
} as const;

export const BREAKDOWN_TYPES = {
  BY_ORGANIZATION: 'REO',
  BY_PRODUCT: 'REP'
} as const;

export const REQUEST_TYPES = {
  CONSIGNMENTS: 'RIC',
  PICKUP: 'RPU'
} as const;

/**
 * Slices whose consignments can be listed. Released cargo is absent on purpose —
 * legacy answers that slice with the breakdown pie instead.
 */
export const CONSIGNMENT_LIST_TYPES = {
  STOCK: 'SOH',
  DELIVERIES: 'RIC',
  PICKUP: 'RPU'
} as const;

export type ConsignmentListType = (typeof CONSIGNMENT_LIST_TYPES)[keyof typeof CONSIGNMENT_LIST_TYPES];

export type CorridorType = (typeof CORRIDOR_TYPES)[keyof typeof CORRIDOR_TYPES];
export type BreakdownType = (typeof BREAKDOWN_TYPES)[keyof typeof BREAKDOWN_TYPES];
export type RequestType = (typeof REQUEST_TYPES)[keyof typeof REQUEST_TYPES];
